var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [
        _vm._v(_vm._s(_vm.$t("message.chatFeature"))),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.autoTranslation,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "autoTranslation", $$v)
                  },
                  expression: "featureForm.autoTranslation",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.autoTranslation")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.voiceCalling,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "voiceCalling", $$v)
                  },
                  expression: "featureForm.voiceCalling",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.voiceCalling")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.videoCalling,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "videoCalling", $$v)
                  },
                  expression: "featureForm.videoCalling",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.videoCalling")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.fileAndVoiceMessage,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "fileAndVoiceMessage", $$v)
                  },
                  expression: "featureForm.fileAndVoiceMessage",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.fileAndVoiceShare")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.chatCopilot,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "chatCopilot", $$v)
                  },
                  expression: "featureForm.chatCopilot",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.aiAssistant")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.liveChat,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "liveChat", $$v)
                  },
                  expression: "featureForm.liveChat",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.liveSupportModule")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.liveScore,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "liveScore", $$v)
                  },
                  expression: "featureForm.liveScore",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.liveTrackingFeature")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.multipleChatWindow,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "multipleChatWindow", $$v)
                  },
                  expression: "featureForm.multipleChatWindow",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.multipleChatWindow")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.shareScreen,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "shareScreen", $$v)
                  },
                  expression: "featureForm.shareScreen",
                },
              },
              [_vm._v(_vm._s(_vm.$t("message.screenSharing")))]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }